export const columns: any[] = [
	{
		title: '序号',
		dataIndex: 'order',
		align: 'center',
		width: 60,
		scopedSlots: { customRender: 'order' },
	},
	{
		title: '录单日期',
		align: 'center',
		dataIndex: 'createTime',
		key: 'createTime',
		scopedSlots: { customRender: 'createTime' },
	},
	{
		title: '任务类型',
		align: 'center',
		dataIndex: 'taskType',
		key: 'taskType',
		scopedSlots: { customRender: 'taskType' },
	},
	{
		title: '订单号',
		align: 'center',
		dataIndex: 'orderNo',
		key: 'orderNo',
	},
	{
		title: '报案号',
		align: 'center',
		dataIndex: 'caseNo',
		key: 'caseNo',
	},
	{
		title: '伤者/家属姓名',
		align: 'center',
		dataIndex: 'injuredName',
		key: 'injuredName',
	},
	{
		title: '录单人',
		align: 'center',
		key: 'creator',
		scopedSlots: { customRender: 'creator' },
	},
	{
		title: '调查所在地',
		width: 200,
		align: 'center',
		dataIndex: 'location',
		key: 'location',
	},
	{
		title: '调查详细地址',
		width: 200,
		align: 'center',
		dataIndex: 'address',
		key: 'address',
	},
	{
		title: '订单状态',
		align: 'center',
		dataIndex: 'orderStatus',
		key: 'orderStatus',
		scopedSlots: { customRender: 'orderStatus' },
	},
	{
		title: '操作',
		align: 'center',
		key: 'action',
		scopedSlots: { customRender: 'action' },
	},
]
